/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CCircularTimer":"CCircularTimer_n0AlW","svg":"svg_hU5dR","secondCircle":"secondCircle_gHhW0","timer":"timer_Xc4-2"};